import { plannerService } from '@/services'

export default async (bookId) => {
  const day = new Date().toLocaleString('en-US', { day: '2-digit', timeZone: 'UTC' })
  const month = new Date().toLocaleString('en-US', { month: '2-digit', timeZone: 'UTC' })
  const year = new Date().toLocaleString('en-US', { year: 'numeric', timeZone: 'UTC' })

  const startDate = `${year}-${month}-${day}`

  const { data } = await plannerService.getEventTags([bookId])

  await plannerService.updateEventTag({
    name: 'example',
    id: data.tags[2].id,
    bookId
  })

  return plannerService.createEvent({
    title: 'This is an event',
    subTitle: 'Create events and drag&drop them, add times, add tags, pages and more...',
    startDate: startDate,
    timeStart: '12:00',
    periodType: 'none',
    periodValue: 0,
    tagIds: [data.tags[2].id, data.tags[4].id],
    bookId: bookId
  })
}
